import { ContentContext, CountryContext, LocaleContext } from 'Components/hooks/context';
import React, { useContext } from 'react';

import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import CovidTrackerHeadlines from '@reuters-graphics/covid-tracker-headlines';
import Headline from './Headline';
import SmartText from '@reuters-graphics/react-smart-text';
import { component } from './styles.module.scss';
import getSmartText from './SmartText';

const atlas = new AtlasMetadataClient();

const TopStats = (props) => {
  const { globalStatistics, caseCounts } = props;

  const locale = useContext(LocaleContext);
  const countrySlug = useContext(CountryContext);
  const content = useContext(ContentContext);

  const country = atlas.getCountry(countrySlug);

  const covidTrackerHeadlines = new CovidTrackerHeadlines({
    globalStatistics: globalStatistics,
    smartText: content.common.headlines,
    locale,
    include: [country.isoAlpha2],
  });

  const headline = covidTrackerHeadlines.getHeadlines(1)[0];

  const latestTotalCases = globalStatistics.latestTotals.cases[country.isoAlpha2];
  const latestTotalDeaths = globalStatistics.latestTotals.deaths[country.isoAlpha2];

  const percentOfPeak = globalStatistics.distributionRanks.cases[country.isoAlpha2];

  const Highlight = ({ number }) => (
    <span className='highlight'>
      {number.toLocaleString(locale)}
    </span>
  );

  const smartText = getSmartText(globalStatistics, caseCounts, country, locale, content.template.headline.smartText);

  return (
    <div className={component}>
      {headline && (
        <Headline {...headline} />
      )}

      {(percentOfPeak && parseInt(smartText.context.cases)) > 0 && (
        <SmartText
          {...smartText}
          wrap
        />
      )}

      <SmartText
        source={content.template.headline.smartText.totals}
        context={{
          cases: <Highlight number={latestTotalCases} key={`${countrySlug}-cases`} />,
          deaths: <Highlight number={latestTotalDeaths} key={`${countrySlug}-deaths`} />,
        }}
        wrap
      />
    </div>
  );
};

export default TopStats;
